

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"16","height":"13","viewBox":"0 0 16 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n", h('path', {"d":"M6.3142 12.3846C6.16147 12.5383 5.95309 12.624 5.73664 12.624C5.52018 12.624 5.31181 12.5383 5.15908 12.3846L0.546513 7.77132C0.0678291 7.29264 0.0678291 6.51643 0.546513 6.03864L1.12407 5.46093C1.60291 4.98224 2.37823 4.98224 2.85691 5.46093L5.73664 8.34081L13.5181 0.559208C13.9969 0.0805244 14.773 0.0805244 15.2509 0.559208L15.8285 1.13692C16.3072 1.6156 16.3072 2.39167 15.8285 2.8696L6.3142 12.3846Z","fill":"#342245"}, []), "\n"]);
};

        